import { HUError, HUErrorCode } from "@modules/error/huError"
import { Lock } from "@modules/core/Lock"
import { type ApiInterceptor } from "@modules/core/api/interceptors/apiInterceptor"
import { LoggerType } from "@modules/utils/loggerUtils"
import { type InternalAxiosRequestConfig } from "axios"
import { getValidToken } from "@/modules/auth/utils/getValidToken"

export const requestAuthorizationInterceptor: (
  jwtTokenRefreshingLock: Lock,
) => ApiInterceptor<InternalAxiosRequestConfig> = (jwtTokenRefreshingLock) => ({
  onFulfilled: async (config) => {
    if (jwtTokenRefreshingLock.exist()) {
      console.error(LoggerType.Token + "waiting refreshing token")
      await jwtTokenRefreshingLock.isReleased()
    }

    try {
      const token = await getValidToken()

      if (token) {
        config.headers.Authorization = `Bearer ${token.toString()}`
      }
    } catch (error) {
      if (error instanceof HUError && error.code === HUErrorCode.Unauthorised) {
        throw error
      }

      console.warn(LoggerType.Token + "failed to get token", error)
      throw error
    }

    return config
  },
})
